export default [
    {
        path: 'relatorio-identificacao',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-identificacao' */
            '@/views/ambulatorio/relatorio-identificacao/Index'
        ),
        redirect: 'relatorio-identificacao/index',
        children: [
            {
                name: 'ambulatorio-relatorio-identificacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-identificacao' */
                    '@/views/ambulatorio/relatorio-identificacao/List.vue'
                ),
            },
        ],
    },
]